module.exports = __webpack_public_path__ + "img/spinner-loop.23f2f1ea.gif";